export const addNewPreconnect = (url: string) => {
  const link = document.createElement("link");
  link.href = url;
  link.rel = "preconnect";

  document.head.append(link);
};
